<template>
    <div style="width:100%">

        <p class="text-small" v-if="description">{{ description }}</p>
        <p v-if="year!=0">{{ year }}</p>
        <p v-if="race">
            <b>Raza: </b>
            <span v-if="race===''"> sin definir</span>
            <span v-else>{{ race }}</span>
        </p>

        <p v-if="origin">
            <b>Origen:</b>&nbsp;
            <span v-if="origin === 'propia'">Producción propia</span>
            <span v-else-if="origin === 'compra'">Comprada</span>
            <span v-else>Otro</span>
        </p>



    </div>
</template>

<script>
export default {
  name: 'infoqueen',
  props: ['description','year','race','origin'],
};
</script>